<template>
   <div class="relative">
      <magnify-icon class="absolute text-gray-500 search-icon"/>
      <input class="shadow appearance-none border rounded w-full py-2 pl-8 pr-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" type="text" :placeholder="placeholder">
    </div>
</template>

<script>
import MagnifyIcon from 'vue-material-design-icons/Magnify.vue'

export default {
  name: 'Search',
  components: {
    MagnifyIcon
  },
  props: {
    placeholder: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>
  .search-icon{
    top:7px;
    left: 5px;
  }
</style>
